import { REPLACE_NAVBAR_ELEMENTS, CLEAR_NAVBAR_ELEMENTS } from "./constants"

export const initialState = {
  navbarElements: () => null,
  className: "navbar-style",
}

// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  const newState = { ...state }
  switch (action.type) {
    case REPLACE_NAVBAR_ELEMENTS:
      newState.navbarElements = action.navbarElements
      break
    case CLEAR_NAVBAR_ELEMENTS:
      newState.navbarElements = initialState.navbarElements
      break
    default:
      return state
  }
  return newState
}
